import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
  const clonedRequest = req.clone({
    setHeaders: {
      'Ocp-Apim-Subscription-Key': environment.msalConfig.subscription_key
    }
  });

  return next(clonedRequest);
};
